module.exports = __webpack_public_path__ + "d5514d2207ec27def19e4b65b7fe4804.svg";